<div class="flex-item">
  <label *ngIf="getArrayControl().length == 1" for="">If the following condition is met:</label>
  <label *ngIf="getArrayControl().length > 1" for="">If the following conditions are met:</label>
</div>
<div
  *ngIf="getArrayControl().length"
  class="form-group flex-item box-item rounded border p-3 mb-3"
  [formGroup]="control"
  style="border: 1px solid black"
>
  <ng-container formArrayName="conditions">
    <ng-container *ngFor="let control2 of getArrayControl(); let i = index">
      <app-common-logic-row-child
        [i]="i"
        [control]="control2"
        [currentQuestion]="currentQuestion"
        [allQuestions]="allQuestions"
        [parentForm]="control"
        [postQuesSet]="postQuesSet"
        [postSameSecQuesSet]="postSameSecQuesSet"
        [continuationCheck]="isChecked"
        [postSecSet]="postSecSet"
        (addRow)="addRow()"
        (updateRaterGroup)="receiveRaterGroup($event)"
        (removeRow)="removeRow($event)"
      >
      </app-common-logic-row-child>
    </ng-container>
    <div class="form-check mb-3" *ngIf="this.currentQuestion._type === 2 && !isRaterGroup">
      <input
        type="checkbox"
        class="form-check-input fsop-checkbox"
        [checked]="isChecked"
        id="prevent_continuation_check{{ i }}"
        (change)="onCheckboxChange($event)"
      />
      <label class="form-check-label" for="prevent_continuation_check{{ i }}" style="line-height: 22px"
        >Prevent continuation
      </label>
    </div>
    <!-- <div class="d-flex align-item-center" *ngIf="this.currentQuestion._type !== 1">
      <label for="" class="me-2">
        Prevent continuation
      </label>
      <label class="switch">
        <input
          type="checkbox"
          [checked]="isChecked"
          (change)="onCheckboxChange($event)"
        />
        <span class="slider round"></span>
      </label>
    </div> -->
    <app-perform-actions-child
      [control]="getFirstConditionControl()"
      [currentQuestion]="currentQuestion"
      [allQuestions]="allQuestions"
      [parentForm]="control"
      [continuationCheck]="isChecked"
      [postQuesSet]="postQuesSet"
      [postSameSecQuesSet]="postSameSecQuesSet"
      [postSecSet]="postSecSet"
      [includeSecQuesSet]="includeSecQuesSet"
      (addRow)="addRow()"
      (removeRow)="removeRow($event)"
    >
    </app-perform-actions-child>
    <!-- <span
      class="remove-box fa fa-times"
      *ngIf="totalParentRows.length > 1"
      (click)="removeLogic(i)"
    ></span> -->
  </ng-container>
</div>
